import { IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { Close, Edit } from "@mui/icons-material";

import FormField from "../FormField";
import ModalAddress from "./modalAddress";
import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";
import AddressService from "../../services/common/address.service";

import { Mode } from "../../constants/enums";
import { IAddress } from "../../commons/interfaces";
import { getFullAddressLine } from "../Profile/userContact";



interface IPropsInputAddress {
    mode?: Mode;
    addressId: string;
    disable?: boolean;
    required?: boolean;
    isFullRow?: boolean;
    errorAddress?: string;
    requiredInputPostalCode?: boolean;
    onChangeData: (addressId: string) => void;
    variant?: "standard" | "outlined";
}

const InputAddress = (props: IPropsInputAddress): JSX.Element => {

    const strings = useStrings();
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [dataAddress, setDataAddress] = useState<IAddress>({} as IAddress);

    useEffect(() => {
        if (!Helpers.isNullOrEmpty(props.addressId)
            && (props.addressId !== "0")
            && Helpers.isNullOrEmpty(dataAddress?.id)) {
            getDetailAddress(props.addressId);
        }
    }, [props.addressId, dataAddress?.id]);

    const getDetailAddress = async (addressId: string) => {
        try {
            const resultAddresses: IAddress[] = await AddressService.getAddressByIds({ ids: [addressId] });

            const itemAddress = resultAddresses.find(el => (el.id === addressId));

            itemAddress && setDataAddress((prev) => ({
                ...prev,
                ...itemAddress,
            }));
        } catch (error) {
            setDataAddress((prev) => ({
                ...prev,
                id: addressId,
            }));
        }
    }

    return (
        <>
            <FormField
                mode={props.mode}
                variant={props.variant}
                disabled={props.disable}
                required={props.required}
                isFullRow={props.isFullRow}
                errorMessage={props.errorAddress}
                label={strings.Profile.ADDRESS_LINE}
                placeholder={strings.Profile.ENTER_ADDRESS_LINE}
                value={props.addressId ? getFullAddressLine(dataAddress) : ""}
                onClick={async () => {
                    props.addressId && await getDetailAddress(props.addressId);
                    setOpenModal(true);
                }}
                InputProps={{
                    startAdornment: props.addressId && (
                        <IconButton
                            color="secondary"
                            sx={{ padding: "0px", paddingRight: "8px" }}
                            onClick={(event: any) => {
                                event.stopPropagation();

                                getDetailAddress(props.addressId);

                                setOpenModal(true);
                            }}
                        >
                            <Edit />
                        </IconButton>
                    ),
                    endAdornment: props.addressId && (
                        <IconButton
                            color="secondary"
                            sx={{ padding: "0px", paddingLeft: "8px" }}
                            onClick={(event: any) => {
                                event.stopPropagation();

                                setDataAddress({});
                                setOpenModal(false);
                                props.onChangeData("");
                            }}
                        >
                            <Close />
                        </IconButton>
                    ),
                }}
            />

            <ModalAddress
                open={openModal}
                dataAddress={dataAddress}
                requiredInputPostalCode={props.requiredInputPostalCode}

                onClose={() => { setOpenModal(false); }}
                onAction={(newDataAddress) => {
                    setDataAddress(newDataAddress);
                    props.onChangeData(newDataAddress.id);
                    setOpenModal(false);
                }}
            />
        </>
    );
};

export default InputAddress;